// extracted by mini-css-extract-plugin
var _1 = "paymentSuccess-module_paymentMainWrapper_Nt2B7";
var _2 = "paymentSuccess-module_paymentWrapper_l3Jdl";
export { _1 as "paymentMainWrapper", _2 as "paymentWrapper" }
